import Navigation from "./navigation.marko";
import LocaleLinks from "./locale-links.marko";
import logo from "../../../img/logo-full.svg";
import MobileMenu from "./mobile-menu.marko";
import t from "../../../locales/common.json";
import { getLocalizedRoute } from "../../../lib/locales";

<style/styles: any>
  .header {
    box-shadow: 0px 4px 80px 0px var(--light-shadow);
  }
</style>

<let/isMenuOpen=false>

<header class=["text-accent relative si-100 z1", styles.header]>
  <div class="wrapper z1 bg-light flex justify-content-between pb-2 align-items-center flex-wrap gap-2">
    <a
      href=getLocalizedRoute("/", $global.locale)
      class="flex text1 align-items-center"
    >
      <img
        style={ height: "2.5ex" }
        src=logo
        alt=t.cc.Header.home
        class="inline-block"
        width="264"
        height="43"
      >
    </a>
    <div class="hidden-lg">
      <button
        type="button"
        class="border-transparent"
        aria-label="Menu"
        onClick() {
          isMenuOpen = !isMenuOpen;
        }
      >
        <menu-icon/>
      </button>
    </div>
    <nav class="hidden block-lg">
      <Navigation class="flex gap0 flex-wrap"/>
    </nav>
    <nav aria-label="Languages" class="hidden block-lg">
      <LocaleLinks class="flex gap-4"/>
    </nav>
  </div>
  <MobileMenu isOpen=isMenuOpen/>
</header>
